export enum SearchScenarioId {
    Mail = 1, // Search box for mail module
    Calendar = 2, // Search box for calendar module
    FilesHub = 3, // Search box for files module
    FilesPicker = 4, // Search box in files picker (for attaching emails)
}

export default SearchScenarioId;
